import { render, staticRenderFns } from "./StaffQuestion.vue?vue&type=template&id=6f10fd6c&scoped=true&"
import script from "./StaffQuestion.vue?vue&type=script&lang=js&"
export * from "./StaffQuestion.vue?vue&type=script&lang=js&"
import style0 from "./StaffQuestion.vue?vue&type=style&index=0&id=6f10fd6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f10fd6c",
  null
  
)

export default component.exports